module.exports = __webpack_public_path__ + "images/2017945e1d2a0fa43959bc0d9c5a7f43b.svg";